const FormatNumbers = (num) => {
    const number = parseFloat(num);
    if (isNaN(number)) return '';

    return number.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",");
};

export default FormatNumbers;